import React from 'react';
import { NavLink } from 'react-router-dom';

const LeaveRequestsCrumb = () => (
  <NavLink to="/human-resources/leave-requests">Leave Requests</NavLink>
);

export default LeaveRequestsCrumb;
